import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Stack, Placeholder } from "react-bootstrap";
import { TODIS_BTN_SECUNDARY, TODIS_DATEPICKER } from "../../../components/Buttons";
import dateFormat, { masks } from "dateformat";
import style from "./Notifications.module.scss";
import { BsCloudSlashFill, BsPersonCircle, BsSortDown } from "react-icons/bs";
import AuthContext from '../../../auth/authContext';
import { FaDatabase, FaCalendar } from "react-icons/fa";
import { HiLocationMarker } from "react-icons/hi";
import { TODIS_FORM_FIELD_GROUP } from "../../../components/Forms";
import { BsGeoAlt, BsGrid, BsGridFill, BsClock, BsSearch, BsSortDownAlt, BsArrowClockwise, BsCalendarMinusFill, BsPlusLg } from "react-icons/bs";
import "../../DataCollection/style.css";
import { NotificationService } from "../../../HttpService/NotificationService";
import { Link, useNavigate } from "react-router-dom";
import { TODIS_PRIMARY_SMALL_BTN } from "../../../components/Buttons";
import arrow from "../../../assets/icons/arrow-white.svg";


const Notifications = ({sm}) => {
    const navigate = useNavigate();
    const {user} = useContext(AuthContext);
    const [order, setOrder] = useState(true)
    const [notifications, setNotifications] = useState([]);
    const [notifyNotFound, setNotifyNotFound] = useState(false)
    const [response, setResponse] = useState(false)
    const [filterR, setFilterR] = useState({"Date": null})
    const [newValue, setNewValue] = useState({}); 
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredNotifications, setFilteredNotifications] = useState([]);;


    const getNotifications = async (filterType, newValue) => {
        try {
            //console.log("usuario", user)
            if(filterType==null){
                const notifications = await new NotificationService("workflow/notifications/" + user.username).getNotifications({limit: 500});
                console.log("All notifications:", notifications); 
                setFilteredNotifications(notifications);
                return notifications;
            }
            else if(filterType=='month'){
                const notifications = await new NotificationService("workflow/notifications/" + user.username).getNotifications({isMonthFilter: true, limit: 500});
                console.log("Month notifications:", notifications); 
                setFilteredNotifications(notifications);
                return notifications;
            }else if(filterType=='week'){
                const notifications = await new NotificationService("workflow/notifications/" + user.username).getNotifications({isWeekFilter: true,limit: 500});
                console.log("Week notifications:", notifications); 
                setFilteredNotifications(notifications);
                return notifications;
            }else if(filterType=='today'){
                const notifications = await new NotificationService("workflow/notifications/" + user.username).getNotifications({isDayFilter: true,limit: 500});
                console.log("Day notifications:", notifications); 
                setFilteredNotifications(notifications);
                return notifications;
            }else{
                console.log("newValue getNot: ", newValue);
                console.log("fromDate: ", newValue["fromDate"]);
                const notifications = await new NotificationService("workflow/notifications/" + user.username).getNotifications({ fromDate: newValue["fromDate"], toDate: newValue["toDate"], limit: 500 });
                console.log("Date notifications:", notifications);
                setFilteredNotifications(notifications);
                return notifications;
            }
        } catch (error) {
          console.log("Error al obtener las notificaciones:", error);
        }
      };

    const refreshRequest = async () => {
        setOrder(true)
        setResponse(false);
        let res = await getNotifications();
        buildNotification(res);
    }

    const orderRequest = (order) => {
        setOrder(!order)
        setFilteredNotifications(prevState => 
            {
                let newState = [...prevState];
                
                return  newState.sort(function (x, y) {
                    if(order)
                        return y.id - x.id;
                    else
                        return x.id - y.id;
                });
            }
        );
    }

    const buildNotification = (res) => {
        if (res) {
            setNotifications(prevState => 
                {                        
                    return  res.sort(function (x, y) {
                        return x.id - y.id;
                    });
                });
            setResponse(true);
        } else {
            setNotifyNotFound(true);
        }
    }
  

    const handleDate = async (value, name) => {
        setFilterR((prevState) => {
          const newValue = { ...prevState };
          newValue[name] = value;
          return newValue;
        });
      
        const dateRange = value.split(' ~ ');
        const newValue = {
          fromDate: dateFormat(dateRange[0], 'dd/mm/yyyy'),
          toDate: dateFormat(dateRange[1], 'dd/mm/yyyy'),
        };
      
        console.log('newValue handleDate: ', newValue);
        setNewValue(newValue);
      
        await getNotifications('date', newValue);
      };
      
      
      

      const handleSearchChange = (event) => {
        const { value } = event.target;
        setSearchTerm(value);
        const filteredNotifications = notifications.filter(notification =>
          notification.message.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredNotifications(filteredNotifications);
      };
      

    const handleButtonClick = (taskId) => {
        sessionStorage.setItem('taskId', taskId);
      };

    useEffect(() => {
        (async () => {
            let res = await getNotifications(null);
            setNotifications(res);
            setFilteredNotifications(res);
            buildNotification(res);
        })();
    }, []);
    

    const now = new Date();
    return (
        <Col sm={sm}>
            <Container fluid className="todis-form-wrapper p-4" style={{height:'95%'}}> 
                <Row className="todis-form-action-panel pb-3">
                    <Col lg={2} className="ps-4">
                        <Stack gap={0}>
                            <h4 className="todis-header">Notifications</h4>
                        </Stack>
                    </Col>
                    <Col lg={10}>
                        <Row className="float-end">
                            <Col lg={2} style={{width: 'auto'}}>
                                <TODIS_BTN_SECUNDARY variant="primary" title="This Month" classes="fw-bolder" onclick={() => getNotifications('month')}/>
                            </Col>
                            <Col lg={2} style={{width: 'auto'}}>
                                <TODIS_BTN_SECUNDARY variant="primary" title="This Week" classes="fw-bolder" onclick={() => getNotifications('week')}/>
                            </Col>
                            <Col lg={2} style={{width: 'auto'}}>
                                <TODIS_BTN_SECUNDARY variant="primary" title="Today" classes="fw-bolder" onclick={() => getNotifications('today')}/>
                            </Col>
                            <Col lg={2} style={{ width: 'auto' }}>
                                <TODIS_DATEPICKER handleDate={(data) => handleDate(data, "Date")} placeholder="Date range" variant="primary" classes="fw-bolder" icon={BsClock} />
                            </Col>
                            <Col lg={2} style={{width: 'auto'}}>
                                <TODIS_FORM_FIELD_GROUP variant="primary" placeholder="Search" classes="fw-bolder" icon={BsSearch} type="notify" onChange={handleSearchChange}/>
                            </Col>
                            <Col lg={1} style={{width: 'auto'}}>
                                <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={order ? BsSortDownAlt : BsSortDown} onclick={() => orderRequest(order)}/>
                            </Col>
                            <Col lg={1} style={{width: 'auto'}}>
                                <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" icon={BsArrowClockwise} onclick={() => refreshRequest()}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="pb-3">
                    
                {
                        !notifyNotFound && response ?
                            (filteredNotifications.map((notification, index) => (
                                <Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}>
                                    <Container className="ms-2">
                                        <Row>
                                            <Col lg={1} className="p-0 w-auto"> 
                                                    <Row className="pe-4">
                                                        <span style={{backgroundColor:"#004494", borderRadius:"10px", paddingLeft:"5px", paddingRight:"5px", height:"50px"}}><BsPersonCircle style={{width:"40px", height:"50px"}} className="m-0" color="#fff"/></span>
                                                    </Row> 
                                            </Col>
                                            <Col lg={11}>
                                                <h4 className="fw-bold" style={{ fontSize: "15px" }}><span className="fw-lighter"></span>{notification.message}</h4>
                                                <Row>
                                                    <Col lg={3} className="w-auto d-flex align-items-center">
                                                        <span><FaCalendar size="18" className="me-1" color="#004494"/> {notification.createdAt}</span>
                                                    </Col>
                                                    <Col lg={3} className="w-auto d-flex align-items-center">
                                                    {user.permissions.some(item => item.id === 2) ? (
                                                        <Link to={`/TODIS-APP/Workflow/tasks/`}>
                                                            <TODIS_PRIMARY_SMALL_BTN title="Task details" type="submit" onClick={() => handleButtonClick(notification.taskId)}/>
                                                        </Link>
                                                    ) : (
                                                        <Link to={`/TODIS-APP/WorkFlow/`}>
                                                            <TODIS_PRIMARY_SMALL_BTN title="Task details" type="submit" onClick={() => handleButtonClick(notification.taskId)}/>
                                                        </Link>
                                                    )}
                                                </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                            ))) : notifyNotFound ?
                                <div className="h-100 d-flex justify-content-center align-items-center"> <div style={{ textAlign: "center" }}>
                                    <BsCloudSlashFill fontSize={100} color="#000000" />
                                    <h3 className="">Notification Not found </h3>
                                </div></div> :

                                // loading tasks 
                                ([...Array(5)].map((task, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container className="float-start">
                                    <Row>
                                        <Col lg={1}>
                                            <Placeholder as="h4" animation="glow"><Placeholder.Button xs={6} size="md" variant="secondary"/></Placeholder>
                                        </Col>
                                        <Col lg={11}>
                                            <Placeholder as="h4" animation="glow"><Placeholder xs={5} size="md" /></Placeholder>
                                            <Row>
                                                <Col lg={2} >
                                                    <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container></Col>)))
                    }
                </Row>
            </Container>
        </Col>
    );
}

export default Notifications;